// Register class
window.brix && window.brix.registerBlock && window.brix.registerBlock('brix-latest-posts', () => {});
